import { api } from "./UrlPadrao"

export const getSolicitacaoAgregados = async (token) => {
  return api.get("SolicitacaoTerceiro",
    {
      headers: {
        'Authorization': token
      }
    })
}

export const postSolicitacaoAgregados = async (id, token) => {
  return api.post("SolicitacaoTerceiro/marcar-como-atendida/" + id, null,
    {
      headers: {
        'Authorization': token
      }
    })
}

export const deleteSolicitacaoAgregados = async (id, token) => {
  return api.delete("SolicitacaoTerceiro/" + id,
    {
      headers: {
        'Authorization': token
      }
    })
}
